import { gql } from '@apollo/client/core';

const checklistFields = `
  id key title subtitle proTip completionTitle completionMessage
  completedCount totalCount isComplete isHidden
  tasks {
    id key section title tooltip details mediaUrl
    actionLabel actionType actionTarget
    isCompleted completedAt canMarkComplete
  }
`;

export const findOnboardingChecklists = gql`
  query ($orgId: UUID!, $placement: String) {
    findOnboardingChecklists(orgId: $orgId, placement: $placement) { ${checklistFields} }
  }`;

export const completeOnboardingTask = gql`
  mutation ($taskId: UUID!, $orgId: UUID!, $completed: Boolean) {
    completeOnboardingTask(taskId: $taskId, orgId: $orgId, completed: $completed) {
      id completedCount totalCount isComplete tasks { id isCompleted completedAt }
    }
  }`;

export const hideOnboardingChecklist = gql`
  mutation ($checklistId: UUID!, $orgId: UUID!, $hidden: Boolean) {
    hideOnboardingChecklist(checklistId: $checklistId, orgId: $orgId, hidden: $hidden) {
      id isHidden
    }
  }`;

export const findHelpLinks = gql`
  query ($placement: String) {
    findHelpLinks(placement: $placement) { id title description url icon }
  }`;

export const trackHelpEvent = gql`
  mutation ($input: HelpEventInput!) { trackHelpEvent(input: $input) }`;

export const cmsLaunchInfo = gql`
  query { cmsLaunchInfo { cmsUrl webUrl hasOrganizations } }`;

export const findAllOnboardingChecklists = gql`
  query {
    findAllOnboardingChecklists {
      id key placement title subtitle proTip completionTitle completionMessage sortOrder isEnabled
      tasks {
        id key section title tooltip details actionLabel actionType actionTarget mediaUrl
        completionRule organizationType sortOrder isEnabled
      }
    }
  }`;

export const onboardingCompletionRules = gql`
  query { onboardingCompletionRules { key description } }`;

export const findAllHelpLinks = gql`
  query { findAllHelpLinks { id placement title description url icon sortOrder isEnabled } }`;

export const findHelpInsights = gql`
  query ($from: DateTime, $to: DateTime, $skip: Int!, $take: Int!) {
    findHelpInsights(from: $from, to: $to, skip: $skip, take: $take) {
      from to questionCount
      tasks { taskId taskKey title tipOpens tipOpenAccounts actionClicks manualCompletions }
      links { helpLinkId title url opens accounts }
      questions { id question page taskId createdAt userName userEmail entity entityName }
    }
  }`;

export const mutateOnboardingChecklist = gql`
  mutation ($input: OnboardingChecklistInput) {
    mutateOnboardingChecklist(input: $input) { id key }
  }`;

export const removeOnboardingChecklist = gql`
  mutation ($checklistId: UUID!) { removeOnboardingChecklist(checklistId: $checklistId) }`;

export const mutateOnboardingTask = gql`
  mutation ($input: OnboardingTaskInput) { mutateOnboardingTask(input: $input) { id key } }`;

export const removeOnboardingTask = gql`
  mutation ($taskId: UUID!) { removeOnboardingTask(taskId: $taskId) }`;

export const reorderOnboardingTasks = gql`
  mutation ($checklistId: UUID!, $taskIds: [UUID!]) {
    reorderOnboardingTasks(checklistId: $checklistId, taskIds: $taskIds) { id }
  }`;

export const mutateHelpLink = gql`
  mutation ($input: HelpLinkInput) { mutateHelpLink(input: $input) { id } }`;

export const removeHelpLink = gql`
  mutation ($helpLinkId: UUID!) { removeHelpLink(helpLinkId: $helpLinkId) }`;
